module.exports = "https://www.gc-qa.gnp.com.mx/3a46938a6f1a42a51801d29894041286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-cobranza-danios.svg
// module id = 8077
// module chunks = 0